export default "__VITE_ASSET__BopmV6ce__"